module.exports = __webpack_public_path__ + "public/img/bar-6.54045013.png";